import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import Swal from 'sweetalert2';
import { userLimits } from '../uitls/userLimits';
import MagexUserModal from './MagexUserModal';
import EditLocationOutlinedIcon from '@mui/icons-material/EditLocationOutlined';
import { MenuItem, Select, Box, Chip, alpha, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GetInvoiceModal from './GetInvoiceModal';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import MagexGeFile from './MagexGeFile';
import ModernTable, { ModernPageHeader } from '../components/ModernTable';
import BusinessIcon from '@mui/icons-material/Business';

const getAllEmployeesURL = `/magexuser/viewAllMagexUsers`;
const deleteUserURL = `/magexuser/deleteMagexUsers/`;

const DropDown = ({ value, onChange }) => (
  <Select onChange={onChange} value={value || ''} size="small">
    <MenuItem value="USD">USD</MenuItem>
    <MenuItem value="CAD">CAD</MenuItem>
  </Select>
);

export default function ViewMagexUser(props) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  const dbaUser = user.dba;

  let history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [reflesh, setReflesh] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [select, setSelect] = useState(null);
  const [field, setField] = useState([]);
  const [getInvoice, setGetInvoice] = useState(false);
  const [showGeFile, setShowGeFile] = useState(false);
  const [rowdata, setrowdata] = useState(null);

  const access = user?.role === 'SuperAdmin' || (user?.role === 'MagexAdmin' && user?.fullAccess);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'get',
        url: getAllEmployeesURL,
      }).then((res) => {
        if (!isCancelled) {
          // console.log('res.data', res.data);
          setEmployees(res.data);
          setIsLoading(true);
        }
      });
    }

    //getAllEmployees
    async function getFields() {
      await request({
        method: 'get',
        url: `/magex/getAllInvoiceFields`,
      }).then((res) => {
        if (!isCancelled) {
          // console.log('res.data', res.data);
          setField(res.data);
          setIsLoading(true);
        }
      });
    }

    getFields();
    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteUser = async (id, referTo) => {
    await request({
      method: 'delete',
      url: deleteUserURL + id,
    }).then(() => {
      Swal.fire({
        text: `The user has been successfully deleted`,
        icon: 'success',
      });
      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const columns = [
    {
      title: 'Operator',
      field: 'operator',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: theme.palette.primary.main,
            fontSize: '0.9rem',
          }}
        >
          {rowData.operator}
        </Typography>
      ),
    },
    {
      title: 'Username',
      field: 'name',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Password',
      field: 'pw',
      render: () => (
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            color: theme.palette.text.secondary,
          }}
        >
          ********
        </Typography>
      ),
    },
    {
      title: 'Currency',
      field: 'currency',
      render: (rowData) => (
        <Chip
          label={rowData.currency || 'USD'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
      editComponent: (props) => (
        <DropDown
          value={props.value}
          onChange={(e) => {
            console.log(e.target.value);
            props.onChange(e.target.value);
          }}
        />
      ),
    },
    {
      title: 'Tolerance($)',
      field: 'tolerance',
      type: 'numeric',
      validate: (rowData) =>
        rowData.tolerance >= -1 || !rowData.tolerance ? true : 'Tolerance cannot be lower than -1',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          ${rowData.tolerance || 0}
        </Typography>
      ),
    },
    {
      title: 'License Fee($)',
      field: 'license_fee',
      type: 'numeric',
      validate: (rowData) =>
        rowData.license_fee >= 0 || !rowData.tolerance
          ? true
          : 'License Fee cannot be lower than 0',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          ${rowData.license_fee || 0}
        </Typography>
      ),
    },
    {
      title: 'Tax(%)',
      field: 'tax',
      type: 'numeric',
      render: (rowData) => (
        <Chip
          label={`${rowData.tax || 0}%`}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
          }}
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.02)} 0%, ${alpha(
          theme.palette.secondary.main,
          0.02
        )} 100%)`,
        pt: { xs: 0.8, sm: 1.2, md: 1.6, lg: 2 },
        px: { xs: 1.6, sm: 2.4, md: 3.2, lg: 4 },
        pb: { xs: 1.6, sm: 2.4, md: 3.2, lg: 4 },
      }}
    >
      {!isloading && <LoadingIcon />}

      {/* Header Section with Title */}
      <ModernPageHeader
        title="Operators"
        subtitle="Manage operator accounts, credentials, and billing settings"
        icon={BusinessIcon}
        buttonText="Preview Invoice"
        buttonIcon={CreateNewFolderIcon}
        onButtonClick={() => setShowGeFile(true)}
      />

      {/* Modern Table */}
      <ModernTable
        columns={columns}
        data={employees}
        localization={{ body: { editRow: { deleteText: 'Are you sure to delete this user' } } }}
          actions={[
            {
              icon: EditLocationOutlinedIcon,
              tooltip: 'Edit Info',
              onClick: (event, rowdata) => {
                // console.log('setSelect', rowdata);
                console.log('setSelect', rowdata);
                setSelect(rowdata);
                setshow(true);
              },
            },
            {
              icon: VisibilityIcon,
              tooltip: 'View Invoice',
              onClick: (event, rowdata) => {
                // console.log('setSelect', rowdata);
                console.log('setSelect', rowdata);
                setSelect(rowdata);
                setGetInvoice(true);
              },
            },
          ]}
          editable={
            !access
              ? {}
              : {
                  onRowDelete: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        deleteUser(newData._id);
                        resolve();
                      }, 1000);
                    }),
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        request({
                          method: 'post',
                          url: `/magexuser/editMagexUser/` + newData?._id,
                          data: {
                            name: newData.name,
                            pw: newData.pw,
                            operator: newData.operator,
                            tolerance: newData.tolerance,
                            license_fee: newData.license_fee,
                            currency: newData.currency,
                            paid_period: newData.paid_period,
                            start_period: newData.start_period,
                            tax: newData.tax,
                          },
                        }).then(() => {
                          Swal.fire({
                            title: 'Success',
                            text: 'User has been successfully updated',
                            timer: 2000,
                          });
                          setReflesh(!reflesh);
                        });

                        resolve();
                      }, 1000);
                    }),
                  onRowAdd: (newData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        // console.log('newData', newData);
                        request({
                          method: 'post',
                          url: `/magexuser/create`,
                          data: {
                            name: newData.name,
                            pw: newData.pw,
                            operator: newData.operator,
                            tolerance: newData.tolerance,
                            license_fee: newData.license_fee,
                            currency: newData.currency,
                            paid_period: newData.paid_period,
                            start_period: newData.start_period,
                            tax: newData.tax,
                          },
                        }).then(() => {
                          Swal.fire({
                            title: 'Success',
                            text: 'User has been successfully created',
                            timer: 2000,
                          });
                          setReflesh(!reflesh);
                        });
                        resolve();
                      }, 1000);
                    }),
                }
          }
          options={{
            actionsColumnIndex: -1,
            rowStyle: (rowData) => {
              if (rowData.dba) {
                return {
                  backgroundColor: alpha(theme.palette.info.main, 0.05),
                  borderLeft: `4px solid ${theme.palette.info.main}`,
                };
              }
            },
            pageSize: 50,
            pageSizeOptions: [50, 100, 150, 200],
          }}
        />

        {/* Back Button */}
        <Box sx={{ mt: 3 }}>
          <BackButton />
        </Box>

        {/* Modals */}
        <MagexUserModal
          show={show}
          field={field}
          onHide={() => setshow(false)}
          setshow={setshow}
          data={select}
          reflesh={reflesh}
          setReflesh={setReflesh}
        />
        <GetInvoiceModal
          show={getInvoice}
          onHide={() => setGetInvoice(false)}
          data={select}
          isloading={isloading}
          setIsLoading={setIsLoading}
        />
        <MagexGeFile
          show={showGeFile}
          onHide={() => setShowGeFile(false)}
          data={employees}
          isloading={isloading}
          setIsLoading={setIsLoading}
          reflesh={reflesh}
          setReflesh={setReflesh}
        />
      </Box>
    );
  }
